import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogActions, MatDialogClose } from "@angular/material/dialog";
import { MatIcon } from "@angular/material/icon";
import { MatButton } from "@angular/material/button";

@Component({
    selector: "dff-info-dialog",
    styleUrls: ["./dff-info-dialog.component.scss"],
    templateUrl: "./dff-info-dialog.component.html",
    imports: [MatIcon, MatDialogActions, MatButton, MatDialogClose]
})
export class DffInfoDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<DffInfoDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}
}
